import { map } from "nanostores"

export interface ConsentBannerStoreProps {
  is_open: boolean
}

export const $consentBanner = map<ConsentBannerStoreProps>({
  is_open: typeof localStorage !== "undefined" ? localStorage.getItem("consentAccepted") !== "true" : false,
})

export const openConsentBanner = () => {
  $consentBanner.setKey("is_open", true)
}

export const closeConsentBanner = () => {
  $consentBanner.setKey("is_open", false)
}
